import { useSelector } from 'react-redux';
import { selectRuntimeConfig } from '@/store/configuration';

/**
 * Read the runtime tenant config (from `GET /api/v1/configuration`, or the
 * local mock during dev). Null until the config layer has loaded.
 */
export const useRuntimeConfig = () => useSelector(selectRuntimeConfig);
